// Centralized route paths and small helpers to avoid hard-coded strings
export const ROUTES = {
  ROOT: '/',
  USERS: '/users',
  ROLES: '/roles',
  DOCUMENTS: '/documents',
  EXCEPTIONS: '/exceptions',
  SETTINGS: '/settings',
  PROJECT_BASE: '/project',
  PROJECT_MANAGEMENT: '/project-management',
  PROJECT_ONBOARDING: '/project-management/project-onboarding',
};

export const projectPath = (projectId) => `${ROUTES.PROJECT_BASE}/${projectId}`;
export const projectOverviewPath = (projectId) => `${projectPath(projectId)}/overview`;
export const regionOverviewPath = (projectId, regionId) => `${projectPath(projectId)}/regions/${regionId}/overview`;
export const procuringEntityPackagesPath = (projectId, peId) => `${projectPath(projectId)}/procuring_entity/${peId}/packages`;
export const procuringEntityReportsPath = (projectId, peId) => `${projectPath(projectId)}/procuring_entity/${peId}/reports`;
export const projectManagementDetailsPath = (projectId) => `${ROUTES.PROJECT_MANAGEMENT}/${projectId}`;
